const TO_BOTTOM_LEFT = { x1: '1', y1: '0', x2: '0', y2: '1' } as const;

export const goldIconGradient = {
  direction: TO_BOTTOM_LEFT,
  stops: [
    { offset: '1.37%', color: '#fff' },
    { offset: '36.66%', color: '#fcff63' },
    { offset: '101.57%', color: '#c26900' },
  ],
} as const;

export const silverIconGradient = {
  direction: TO_BOTTOM_LEFT,
  stops: [
    { offset: '10.85%', color: '#fff' },
    { offset: '51.57%', color: '#99bdc8' },
    { offset: '100.02%', color: '#616161' },
  ],
} as const;

export const bronzeIconGradient = {
  direction: TO_BOTTOM_LEFT,
  stops: [
    { offset: '13%', color: '#fff' },
    { offset: '20%', color: '#ffa463' },
    { offset: '90%', color: '#a06329' },
  ],
} as const;
